module.exports = __webpack_public_path__ + "img/img-aml@2x.b3e09cd9.png";